<!-- start banner Area -->
<section class="top-banner">
  <div class="top-banner-img" style="">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 style="padding: 80px 0px 80px 0px !important;"> Portail administrateur</h1>
        </div>
      </div>
    </div>
  </div>
</section>
<br> <br>
<!-- End banner Area -->

<!-- Start service Area -->
<section class="service-area section-gap" id="service">
  <div class="container">
    <!-- <p class="header-signin">Portail administrateur</p> -->
    <div class="card mb-5">
      <div class="card-body">
        <div class="row d-flex justify-content-center">
          <form class="col-md-6 pb-40 form-area" [formGroup]="signInForm" (ngSubmit)="onSubmitForm()">
            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" class="form-control" id="email" formControlName="email">
            </div>
            <div class="form-group">
              <label for="password">Mot de passe</label>
              <input type="password" class="form-control" id="password" formControlName="password">
            </div>
            <div class="d-flex">
              <button type="submit" class="btn btn-submit text-white mb-4" [disabled]="signInForm.invalid">Se
                connecter</button>
              <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="isLoading">Veuillez
                patienter...
              </p>
            </div>
            <div class="form-group">
              <a [routerLink]="['/mot-de-passe-oublie', 'admin']" style="font-size: 13px; color: #FF5A00;">Mot de passe
                oublié ?</a>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</section>
<!-- End service Area -->